// Sourced from the official Talanta Hela programme decks (Sports R2 / Talanta Digital R4).
export const LEADERS = [
  {
    name: "Hon. Salim Mvurya, EGH",
    initials: "SM",
    photo: "/leaders/mvurya.jpg",
    title: "Cabinet Secretary, Ministry of Youth Affairs, the Creative Economy & Sports",
    quote:
      "The Talanta Hela Sports, Creative, and Enterprise IP Platform embodies the next frontier of Kenya's talent economy — where athletic excellence, artistic ingenuity, and entrepreneurial spirit converge to unlock new opportunities for our youth and position Kenya on the global stage.",
  },
  {
    name: "Hon. William Kabogo Gitau",
    initials: "WK",
    photo: "/leaders/kabogo.jpg",
    title: "Cabinet Secretary, Ministry of Information, Communications & the Digital Economy",
    quote:
      "The Talanta Hela Sports, Creative, and Enterprise IP Platform represents the future of Kenya's digital economy — where technology meets talent, fostering innovation, financial inclusion, and global competitiveness.",
  },
];

export const MINISTRIES = [
  { tag: "Lead ministry", name: "Ministry of Youth Affairs, Creative Economy & Sports", role: "Core mandate: nurture talent, expand livelihoods and elevate Kenya's sporting and creative industries.", link: "https://moyasa.go.ke" },
  { tag: "Digital partner", name: "Ministry of Information, Communications & the Digital Economy", role: "Accelerates digital transformation — infrastructure, Talanta WiFi, e-commerce and content monetization.", link: "https://ict.go.ke" },
  { tag: "Implementing agency", name: "Kenya Academy of Sports & Sports Kenya", role: "Runs the sports pipeline: Digital Hub, academies, talent camps and athlete progression.", link: "https://kas.or.ke" },
  { tag: "Supporting ministries", name: "Foreign & Diaspora Affairs · Gender, Culture, Arts & Heritage · Education · Labour", role: "Diaspora markets and remittances, culture and heritage, TVETA-accredited training and labour mobility.", link: "https://www.mfa.go.ke" },
];

export const WHY_STATS = [
  { value: "75%", label: "of Kenyans are under 35 years old" },
  { value: "35%", label: "youth unemployment — 4.5M young people, vs 10% national" },
  { value: "66M", label: "cellular mobile connections nationwide" },
  { value: "22.7M", label: "Kenyans online — ready for the digital economy" },
];

export const PARTNERS = [
  "ai.io", "imagineBC", "Arabsat", "Safaricom", "M-PESA", "Konza Technopolis", "Mastercard", "VISA", "Equity", "KCB",
  "Ajira Digital", "SwahiliPot", "Hustler Fund", "Football Kenya Federation", "Esports Federation of Kenya", "TVETA",
  "United Cities Sport", "Clearbrook", "Visit Sasa", "Tourism Fund",
];
